import { ApiError, NetworkError, api } from "./api.ts";
import { t, tryT } from "./i18n.ts";
import { useRemote } from "./useRemote.ts";

/** Справочники для форм: категории, счета, члены семьи, имя бота. */
export function useMeta() {
  return useRemote("meta", () => api.meta());
}

/** Понятный текст ошибки действия: что случилось и что сделать. */
export function errorText(err: unknown): string {
  if (err instanceof NetworkError) return t("needOnlineOp");
  if (err instanceof ApiError) return tryT(err.code) ?? t("err.generic");
  return t("err.generic");
}
